import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Datenschutz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Header />
      
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl font-bold text-gray-900 mb-12 text-center">Datenschutzerklärung</h1>
          
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 prose prose-lg max-w-none">
            <h2>Datenschutzerklärung Ambulante Pflege Großstadtherzen® UG</h2>
            
            <h3>Geltungsbereich der Datenschutzerklärung</h3>
            <p>
              Für alle unsere Internetseiten, Onlineangebote. Die Datenschutzerklärung ist nicht gültig für andere Internetseiten, die mit unserer Website verlinkt sind.
            </p>

            <h3>Informationen zur Datenerhebung gemäß Artikel 13 DSGVO</h3>
            <p>
              Unser Pflegedienst erhebt und verarbeitet Ihre Daten. Wir sind darum, nach den ab dem 25.05.2018 geltenden neuen gesetzlichen Vorschriften zum Datenschutz verpflichtet, Sie wie folgt zu informieren:
            </p>
            <p>
              <strong>Ambulante Pflege Großstadtherzen® UG</strong><br />
              Zschochersche Straße 49<br />
              04229 Leipzig<br />
              Deutschland
            </p>
            <p>
              Tel.: <a href="tel:034124927833">0341/24927833</a><br />
              E-Mail: <a href="mailto:info@grossstadtherzen.de">info@grossstadtherzen.de</a><br />
              HRB 38053
            </p>
            <p>
              <strong>Geschäftsführerin:</strong> Peggy Kriegenherdt
            </p>
            <p>
              <strong>Die Verantwortung für Ihren Datenschutz liegt bei:</strong><br />
              Herr Kevin Groß
            </p>
            <p>
              <strong>Datenschutzbeauftragter:</strong><br />
              Die Pflegedienstberater<br />
              Herr Reiner Henrich<br />
              Waldweg 4<br />
              35764 Sinn<br />
              Tel.: +49 (0) 6449 - 719 20 47<br />
              E-Mail: info@dpberater.de
            </p>

            <h3>Datenerfassung auf unserer Website</h3>
            <p>
              Beim Aufrufen unserer Website werden durch den Browser automatisch Informationen an den Server übertragen. Diese Informationen werden temporär in einem sog. Logfile gespeichert:
            </p>
            <ul>
              <li>IP-Adresse des anfragenden Rechners</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Name und URL der abgerufenen Datei</li>
              <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
              <li>Verwendeter Browser und ggf. das Betriebssystem</li>
            </ul>
            <p>
              Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
            </p>

            <h3>Betroffenenrechte</h3>
            <p>Sie haben folgende Rechte:</p>
            <ul>
              <li><strong>Recht auf Auskunft (Art. 15 DSGVO)</strong></li>
              <li><strong>Recht auf Berichtigung (Art. 16 DSGVO)</strong></li>
              <li><strong>Recht zum Widerruf (Art. 7 Abs. 3 DSGVO)</strong></li>
              <li><strong>Recht zum Widerspruch (Art. 21 DSGVO)</strong></li>
              <li><strong>Recht zur Löschung (Art. 17 DSGVO)</strong></li>
              <li><strong>Beschwerderecht (Art. 77 DSGVO)</strong></li>
              <li><strong>Recht auf Datenübertragung</strong></li>
            </ul>

            <h3>Widerspruch gegen Werbe-Mails</h3>
            <p>
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen.
            </p>

            <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
            <p>
              Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <p>
              <strong>Landesdatenschutzbehörde</strong><br />
              Der Sächsische Datenschutzbeauftragte<br />
              Devrienstraße 1<br />
              01067 Dresden
            </p>
            <p>
              Telefon: +49 (0) 351 493 540 1<br />
              Telefax: +49 (0) 351 493 549 0<br />
              Email: sachsdsb@slt.sachsen.de
            </p>

            <h3>Server-Log-Files</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Files:
            </p>
            <ul>
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>

            <h3>SSL-Verschlüsselung</h3>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt.
            </p>

            <h3>Cookies</h3>
            <p>
              Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die bestimmte Einstellungen und Daten zum Austausch mit unserem System über Ihren Browser speichern.
            </p>
            <p>
              Wir unterscheiden zwischen technisch notwendigen Cookies (z.B. für die Funktion der Website) und optionalen Cookies (z.B. für Analysezwecke). Beim ersten Besuch unserer Website werden Sie über ein Cookie-Banner nach Ihrer Einwilligung gefragt. Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie die Cookies in Ihrem Browser löschen.
            </p>

            <h3>Google Analytics</h3>
            <p>
              Diese Website nutzt Google Analytics 4, einen Webanalysedienst der Google Ireland Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Irland. Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie ermöglichen.
            </p>
            <p>
              <strong>Die Nutzung von Google Analytics erfolgt nur mit Ihrer ausdrücklichen Einwilligung</strong> (Art. 6 Abs. 1 lit. a DSGVO). Diese Einwilligung erteilen Sie über unser Cookie-Banner. Ohne Ihre Einwilligung werden keine Analysedaten erhoben.
            </p>
            <p>
              Wir verwenden Google Analytics mit der Erweiterung "anonymizeIp()". Dadurch werden IP-Adressen gekürzt weiterverarbeitet, eine Personenbeziehbarkeit kann damit ausgeschlossen werden. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.
            </p>
            <p>
              Weitere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>.
            </p>
            <p>
              Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das Browser-Add-on unter folgendem Link herunterladen und installieren: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a>.
            </p>

            <h3>Einsatz von Künstlicher Intelligenz (KI)</h3>
            <p>
              Auf dieser Website werden KI-gestützte Technologien eingesetzt. Im Folgenden informieren wir Sie transparent über den Einsatz und die Datenverarbeitung.
            </p>
            
            <h4>Art der KI-Nutzung</h4>
            <p>
              Diese Website wurde mit Unterstützung von Künstlicher Intelligenz erstellt und wird teilweise durch KI-Systeme betrieben. Dies umfasst:
            </p>
            <ul>
              <li>Entwicklung und Programmierung der Website</li>
              <li>Optimierung von Inhalten und Benutzeroberfläche</li>
              <li>Technische Wartung und Fehlerbehebung</li>
            </ul>
            
            <h4>Datenverarbeitung durch KI</h4>
            <p>
              Bei der Nutzung von KI-Diensten können folgende Daten verarbeitet werden:
            </p>
            <ul>
              <li>Technische Daten zur Website-Entwicklung und -Optimierung</li>
              <li>Anonymisierte Nutzungsdaten zur Verbesserung der Benutzererfahrung</li>
            </ul>
            <p>
              <strong>Wichtig:</strong> Es werden keine personenbezogenen Daten unserer Klienten oder Besucher an KI-Systeme übermittelt. Die KI wird ausschließlich für technische und gestalterische Zwecke der Website eingesetzt.
            </p>
            
            <h4>Rechtsgrundlage</h4>
            <p>
              Die Rechtsgrundlage für den Einsatz von KI-Technologien ist unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO, eine moderne, benutzerfreundliche und technisch einwandfreie Website bereitzustellen.
            </p>
            
            <h4>Ihre Rechte</h4>
            <p>
              Sie haben jederzeit das Recht, Auskunft über die Verarbeitung Ihrer Daten zu erhalten und können der Verarbeitung widersprechen. Kontaktieren Sie uns hierzu unter den oben angegebenen Kontaktdaten.
            </p>

            <h3>Änderungen dieser Datenschutzerklärung</h3>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>
            
            <p className="text-sm text-gray-500 mt-8">
              <strong>Stand:</strong> Februar 2026
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Datenschutz;
